export const safeStringify = (object) => {
  return JSON.stringify(object)?.replace(/</g, '\\u003c')
}

export const formatCurrency = (currency, currencyCode) => {
  let formatter = null;
  const isNotCrypto = currencyCode === 'USD'
  if (currencyCode && isNotCrypto) {
    formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currencyCode || "USD",
      signDisplay: "auto",
      minimumFractionDigits: 2,
    });
  } else {
    formatter = new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      signDisplay: "auto",
    });
  }

  const formattedAmount = formatter.format(currency);
  return formattedAmount.startsWith('-') ? formattedAmount.substring(1) : formattedAmount;
}

export const searchRegEx = /[^\w\s+@.]/gi

export const permissionLabel = (label) => {
  switch (label) {
    case 'C':
      return 'Create'
    case 'R':
      return 'Read'
    case 'DR':
      return 'Dashboard Reports'
    case 'U':
      return 'Update'
    case 'D':
      return 'Delete'
    case 'T':
      return 'Toggle Status'
    case 'A':
      return 'Apply'
    case 'GC':
      return 'Create Custom'
    case 'SR':
      return 'Limit'
    case 'AB':
      return 'Manage Wallet'
    case 'TE':
      return 'Test Email'
    default:
      return label
  }
}

export const customLabel = (label) => {
  switch (label) {
    case 'C':
      return 'Assign'
    case 'R':
      return 'Read'
    case 'U':
      return 'Resolve'
    default:
      return label
  }
}


// dateUtils.js
export const getDateRangeByFilter = (filterKey, previousState) => {

  const today = new Date();
  let startDate, endDate;

  switch (filterKey) {
    case "today":
      startDate = new Date(today);
      endDate = new Date(today);
      break;

    case "yesterday":
      startDate = new Date(today);
      startDate.setDate(today.getDate() - 1);
      endDate = new Date(today);
      endDate.setDate(today.getDate() - 1);
      break;

    case "this_week": {
      const dayOfWeek = today.getDay(); // Sunday=0
      startDate = new Date(today);
      startDate.setDate(today.getDate() - dayOfWeek); // Move back to Sunday
      endDate = new Date(today); // Current day
      break;
    }

    case "this_month":
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today);
      break;

    case "lifetime":
      startDate = null;
      endDate = null;
      break;




    case "custom":
    default:
      // Just return previous state values (don't change anything)
      startDate = previousState?.[0]?.startDate || null;
      endDate = previousState?.[0]?.endDate || null;
      break;
  }

  return {
    startDate,
    endDate,
    key: "selection"
  };
};


export const defaultDateFilter = "this_month"
export const defaultCustom = "custom"